export default function fairCountdown() {
  const widgetName = 'fairCountdown';
  const widgetOpts = fairCountdownOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCountdown(data.items[0], $widget, widgetName);
      }
    },
  });
}

function createCustomCountdown(data, $widget, widgetName) {
  const currentDate = new Date();

  if (data.DetailLinkText == 'More') {
    $widget.remove();
  } else {
    const countDownData = datesExtraction(data, currentDate);
    $widget.replaceWith(createCustomStructure(countDownData));
    updateBodyClass(`${widgetName}-${countDownData.event_status.status}`);
  }
}

// -------------------------
// dates extraction and dates validation
function datesExtraction(data, todayDate) {
  const {
    Title: countdownText,
    DetailLinkText: countdownDates,
    Description: thankyouMessage,
  } = data;

  const countdownConfig = {};

  countdownConfig.countdown_title = countdownText;
  countdownConfig.thankYou_config = validateThankYouMessage(thankyouMessage);

  if (!countdownDates) {
    countdownConfig.countdown = false;
    return countdownConfig;
  }

  countdownConfig.countdown = true;
  countdownConfig.current_date = todayDate;

  let fixedDate;

  if (countdownDates.includes(' | ')) {
    fixedDate = countdownDates.split(' | ');
  } else {
    fixedDate = [countdownDates, countdownDates];
  }

  const { day: dayStart, month: monthStart, year: yearStart } = parseDateParts(fixedDate[0]);
  const { day: dayEnd, month: monthEnd, year: yearEnd } = parseDateParts(fixedDate[1]);

  const dateStartObj = new Date(yearStart, monthStart - 1, dayStart);
  const dateEndObj = new Date(yearEnd, monthEnd - 1, dayEnd);

  const dateStartStr = `${String(monthStart).padStart(2, '0')}-${String(dayStart).padStart(2, '0')}-${yearStart}`;
  const dateEndStr = `${String(monthEnd).padStart(2, '0')}-${String(dayEnd).padStart(2, '0')}-${yearEnd}`;

  if (dateEndObj < dateStartObj || dateStartObj.getTime() === dateEndObj.getTime()) {
    countdownConfig.dual_event = false;
    countdownConfig.event_start = dateStartStr;
  } else {
    countdownConfig.dual_event = true;
    countdownConfig.event_start = dateStartStr;
    countdownConfig.event_end = dateEndStr;
  }

  countdownConfig.event_status = validateStatusEvent(dateStartObj, dateEndObj, todayDate);

  countdownConfig.dates_string = createStringMonths(dateStartObj, dateEndObj);
  return countdownConfig;
}

// -------------------------
// thank you message check
function validateThankYouMessage(tksMessage) {
  const thanksConfig = {};
  const thanksMessageOn = tksMessage && tksMessage.trim().length > 0;

  if (thanksMessageOn) {
    thanksConfig.status = true;
    thanksConfig.message = tksMessage;
  } else {
    thanksConfig.status = false;
    $('body').addClass('no-thanks-message');
  }

  return thanksConfig;
}

// -------------------------
// status event
function validateStatusEvent(start, _end, current) {
  const eventStatus = {};
  const startPast = datePast(start, current);
  const endPast = datePast(_end, current);

  if (startPast.status && endPast.status) {
    eventStatus.status = 'past';
    eventStatus.days_left = startPast.days;
  } else if (startPast.status && !endPast.status) {
    eventStatus.status = 'happening';
    eventStatus.days_left = startPast.days;
  } else {
    eventStatus.status = 'future';
    eventStatus.days_left = startPast.days;
  }

  return eventStatus;
}

// -------------------------
// validate timestamp
function datePast(eventDate, current) {
  const event = normalize(eventDate);
  const now = normalize(current);

  const diffTime = event - now;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 0) {
    return { status: true, days: diffDays };
  } else {
    return { status: false, days: diffDays };
  }
}

// -------------------------
// helper to transform months
function convertMonthToText(m) {
  const monthNumbers = {
    0: 'January',
    1: 'February',
    2: 'March',
    3: 'April',
    4: 'May',
    5: 'June',
    6: 'July',
    7: 'August',
    8: 'September',
    9: 'October',
    10: 'November',
    11: 'December',
  };
  return monthNumbers[m];
}

// -------------------------
// date string builder
function createStringMonths(start, _end) {
  if (!start) return '';

  const formatDate = (date) =>
    `${convertMonthToText(date.getMonth())} ${date.getDate()}, ${date.getFullYear()}`;

  if (!_end || _end.getTime() <= start.getTime()) {
    return formatDate(start);
  }

  if (start.getFullYear() === _end.getFullYear()) {
    if (start.getMonth() === _end.getMonth()) {
      return `${convertMonthToText(start.getMonth())} ${start.getDate()} - ${_end.getDate()}, ${start.getFullYear()}`;
    } else {
      return `${convertMonthToText(start.getMonth())} ${start.getDate()} - ${convertMonthToText(_end.getMonth())} ${_end.getDate()}, ${start.getFullYear()}`;
    }
  } else {
    return `${formatDate(start)} - ${formatDate(_end)}`;
  }
}

// -------------------------
// body class function
function updateBodyClass(countdownStatusClass) {
  $('body').addClass(countdownStatusClass);
}

// -------------------------
// countdown template
function createCustomStructure(data) {
  // no countdown or thank you message disabled
  if (!data.countdown && !data.thankYou_config.status) {
    return '';
  }

  // aux for thank you template
  const renderThankYou = (message) => `
    <div id="fair-countdown">
      <span class="count-text">${message}</span>
    </div>
  `;

  // past event
  if (data.event_status.status === 'past') {
    return data.thankYou_config.status ? renderThankYou(data.thankYou_config.message) : '';
  }

  // future or happening event
  if (data.countdown) {
    const countdownDays =
      data.event_status.status === 'future' && data.event_status.days_left > 0
        ? `<span class="count-days">${data.event_status.days_left} days</span>`
        : '';

    return `
      <div id="fair-countdown">
        <div class="count-data">
          <span class="count-dates">${data.dates_string}</span>
          <div class="count-text">
            ${countdownDays}
            <span class="count-text">${data.countdown_title}</span>
          </div>
        </div>
      </div>
    `;
  }

  // no countdown but thank you message enabled
  if (data.thankYou_config.status) {
    return renderThankYou(data.thankYou_config.message);
  }

  return '';
}

function parseDateParts(dateStr) {
  const [month, day, year] = dateStr.split('-').map((n) => Number.parseInt(n, 10));
  return { day, month, year };
}

function normalize(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
